module.exports = __webpack_public_path__ + "static/media/icon-pis-cofins-diesel.2a5872be.svg";